import ObjectActionsType from "../types/ObjectActionsType";
import ObjectStateActionUtils from "./ObjectStateActionUtils";
export default class ObjectStateReducerUtils {
    static getInitialState() {
        return {
            object: undefined,
            isLoading: false,
            loadError: undefined,
            isSaving: false,
            saveError: undefined
        };
    }
    static getLoadedState(object) {
        return {
            object: object,
            isLoading: false,
            loadError: undefined,
            isSaving: false,
            saveError: undefined
        };
    }
    static getSavedState(object) {
        return {
            object: object,
            isLoading: false,
            loadError: undefined,
            isSaving: false,
            saveError: undefined
        };
    }
    static getLoadingState() {
        return {
            object: undefined,
            isLoading: true,
            loadError: undefined,
            isSaving: false,
            saveError: undefined
        };
    }
    static getReLoadingState(object) {
        return {
            object: object,
            isLoading: true,
            loadError: undefined,
            isSaving: false,
            saveError: undefined
        };
    }
    static getSavingState(object) {
        return {
            object: object,
            isLoading: false,
            loadError: undefined,
            isSaving: true,
            saveError: undefined
        };
    }
    static getLoadFailedState(error) {
        return {
            object: undefined,
            isLoading: false,
            loadError: error,
            isSaving: false,
            saveError: undefined
        };
    }
    static getReLoadFailedState(error, object) {
        return {
            object: object,
            isLoading: false,
            loadError: error,
            isSaving: false,
            saveError: undefined
        };
    }
    static getSaveFailedState(object, error) {
        return {
            object: object,
            isLoading: false,
            loadError: undefined,
            isSaving: false,
            saveError: error,
        };
    }
    static getStateWithUpdatedElement(currentState, updatedElement, predicate) {
        if (Array.isArray(currentState.object)) {
            // Find object
            const array = currentState.object;
            const ix = array.findIndex(predicate);
            if (ix >= 0) {
                array[ix] = updatedElement;
            }
            else {
                array.push(updatedElement);
            }
            return {
                ...currentState,
                object: array
            };
        }
        return currentState;
    }
    static createHandlers(reduxStateKey) {
        return {
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.LOAD_STARTED)]: (state) => {
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getLoadingState(),
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.LOAD_SUCCESS)]: (state, action) => {
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getLoadedState(action.object),
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.LOAD_FAILED)]: (state, action) => {
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getLoadFailedState(action.error)
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.RELOAD_STARTED)]: (state) => {
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getReLoadingState(state[reduxStateKey]['object']),
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.RELOAD_SUCCESS)]: (state, action) => {
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getLoadedState(action.object),
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.RELOAD_FAILED)]: (state, action) => {
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getReLoadFailedState(action.error, state[reduxStateKey]['object'])
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.SAVE_STARTED)]: (state, action) => {
                const currentObject = state[reduxStateKey].object || action.object;
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getSavingState(currentObject),
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.SAVE_SUCCESS)]: (state, action) => {
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getSavedState(action.object),
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.SAVE_FAILED)]: (state, action) => {
                const currentObject = state[reduxStateKey].object;
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getSaveFailedState(currentObject, action.error)
                };
            },
            [ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.ELEMENT_UPDATED)]: (state, action) => {
                const updatedElement = action.element;
                const predicate = action.predicate;
                return {
                    ...state,
                    [reduxStateKey]: ObjectStateReducerUtils.getStateWithUpdatedElement(state[reduxStateKey], updatedElement, predicate)
                };
            }
        };
    }
}
//# sourceMappingURL=ObjectStateReducerUtils.js.map